import { createFeature, createReducer, on } from '@ngrx/store';
import { Emr } from '@models/emr.model';
import { EmrActions } from '@store/actions/emr/emr.actions';

export const emrFeatureKey = 'emr';

export interface State {
  emrs: Emr[];
}

export const initialState: State = {
  emrs: [],
};

export const reducer = createReducer(
  initialState,

  on(EmrActions.loadEmrsSuccess, (state, action) => ({
    ...state,
    emrs: action.emrs,
  })),
);

export const emrFeature = createFeature({
  name: emrFeatureKey,
  reducer,
});
